<template>
  <div class="row">
    <uspAlerta
      class="col-lg-10 offset-lg-1"
      :variante="alert.variant"
      :show="!!alert.message"
      v-if="alert.target == 'alterarSenha'"
    >
      <span v-html="alert.message"></span>
    </uspAlerta>
    <div class="col-lg-5 offset-lg-1">
      <form @submit.prevent="alterarSenha" novalidate>
        <div class="form-group">
          <label class="sr-only" for="loginUsuario">Login</label>
          <input
            id="loginUsuario"
            type="hidden"
            name="loginUsuario"
            class="form-control"
            placeholder="Login"
            v-model="loginUsuario"
          />
        </div>
        <div class="form-group">
          <label class="sr-only" for="senhaAtual">Senha Atual</label>
          <input
            id="senhaAtual"
            type="password"
            name="senhaAtual"
            class="form-control"
            placeholder="Senha Atual"
            v-model="senhaAtual"
          />
        </div>
        <div class="form-group">
          <label class="sr-only" for="senhaNova">Nova Senha</label>
          <input
            id="senhaNova"
            type="password"
            name="senhaNova"
            class="form-control"
            placeholder="Nova Senha"
            v-model="senhaNova"
          />
        </div>
        <div class="form-group">
          <label class="sr-only" for="senhaNovaConfirmada"
            >Confirmar Nova Senha</label
          >
          <input
            id="senhaNovaConfirmada"
            type="password"
            name="senhaNovaConfirmada"
            class="form-control"
            placeholder="Confirmar Nova Senha"
            v-model="senhaNovaConfirmada"
          />
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-block mb-2"
          :disabled="
            carregando ||
              !validoTamanhoMinimo ||
              !validoNumero ||
              !validoLetra ||
              !validoEspecial ||
              !validoVerificacao ||
              senhaAtual == '' ||
              loginUsuario == ''
          "
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="carregando"
          ></span>
          Alterar Senha
        </button>
      </form>
    </div>
    <div class="col-lg-5">
      <ul class="regras">
        <li class="header">A senha deve:</li>
        <li
          :class="{
            valido: senhaNova && validoTamanhoMinimo,
            invalido: senhaNova && !validoTamanhoMinimo,
          }"
        >
          Ter no mínimo 8 caracteres
        </li>
        <li
          :class="{
            valido: senhaNova && validoNumero,
            invalido: senhaNova && !validoNumero,
          }"
        >
          Possuir um número
        </li>
        <li
          :class="{
            valido: senhaNova && validoLetra,
            invalido: senhaNova && !validoLetra,
          }"
        >
          Possuir uma letra maiúscula e uma minúscula
        </li>
        <li
          :class="{
            valido: senhaNova && validoEspecial,
            invalido: senhaNova && !validoEspecial,
          }"
        >
          Possuir um caracter especial
        </li>
        <li
          :class="{
            valido: senhaNova && validoVerificacao,
            invalido: senhaNova && !validoVerificacao,
          }"
        >
          Ser confirmada no campo "Confirmar Senha"
        </li>
        <li class="header mt-2">Além disso, a senha:</li>
        <li>
          Não deve conter 3 ou mais caracteres consecutivos do seu nome ou do login
        </li>
        <li>
          Não pode repetir as 3 últimas senhas
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AlterarSenha',

  data(){
    return{
      erros: [],
      alert: {
        variant: 'perigo',
        message: "",
        target: ""
      },
      carregando: false,
      loginUsuario: "",
      senhaAtual: "",
      senhaNova: "",
      senhaNovaConfirmada: "",      
  }
  },

  created(){
    this.loginUsuario =  this.usuarioLogado.replace(' ','').split('-')[0];
  },

  computed:{
    erro(){
      return this.erros.join("<br/>")
    },
    validoTamanhoMinimo(){
      return /^(?=.{8,})/.test(this.senhaNova)
    },
    validoNumero(){
      return /^(?=.*[0-9])/.test(this.senhaNova)
    },
    validoLetra(){
      return /^(?=.*[a-z])/.test(this.senhaNova) && /^(?=.*[A-Z])/.test(this.senhaNova)
    },
    validoEspecial(){
      // eslint-disable-next-line no-useless-escape
      return /^(?=.*[!@#\$%\^&\*\_])/.test(this.senhaNova)
    },
    validoVerificacao(){
      return this.senhaNovaConfirmada && this.senhaNova == this.senhaNovaConfirmada
    },
    usuarioLogado() {
      return this.$store.getters["auth/usuarioLogado"];
    }, 
  },
  methods:{
    alterarSenha(){
      const self = this
      self.carregando = true
      self.$store.dispatch('auth/alterarSenha',{
        loginUsuario: self.loginUsuario,
        senhaAtual: self.senhaAtual,
        senhaNova: self.senhaNova,
        senhaNovaConfirmada: self.senhaNovaConfirmada
      }).then(resposta => {
        self.alert.message = resposta.mensagem
        self.alert.variant = 'sucesso'
        self.alert.target = 'alterarSenha'
      }).catch(erro => {
        self.alert.message = erro.mensagem
        self.alert.variant = 'perigo',
        self.alert.target = 'alterarSenha'
        })
      .finally(() => self.carregando = false)
    },
  }
}
</script>

<style>
.regras {
  list-style: none;
}

.regras .header {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.valido {
  color: green;
}

.invalido {
  color: red;
}
</style>
